module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-dialog-warp"
  }, [_c('div', {
    staticClass: "com-dialog-main"
  }, [_c('h5', {
    staticClass: "com-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "com-dialog-content"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('div', {
    staticClass: "com-dialog-footer"
  }, [_c('a', {
    staticClass: "com-dialog-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.btnCancel))]), _vm._v(" "), _c('a', {
    staticClass: "com-dialog-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.btnConfirm))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-720926ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/common/myDialog.vue
// module id = 362
// module chunks = 0